import { exists } from '@/api'

export interface BatchReminderPostcardConditionListItem {
  returnPlansDateFrom: string
  returnPlansDateTo: string
  dunningDateFrom: string
  dunningDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  radioBranchType: string
  radioUserType: string
  userCodeFrom: string
  userCodeTo: string
  radioUpdate: string
  isUserOutputMultiple: boolean
  isOrderTelInclude: boolean
  isNotLostCollection: boolean
  isNotLostProcedure: boolean
  isRsvCollection: boolean
  isOtherDunningDoc: boolean
  isOutputParents: boolean
  targetAge: string
  isOutputTitle: boolean
  isMailApplicant: boolean
  isOutputDeterrence: boolean
  batchType: string
}

export function BatchReminderListConditionPostcardItemFromJSON(
  json: any
): BatchReminderPostcardConditionListItem {
  const resp = JSON.parse(json)

  return {
    returnPlansDateFrom: exists(resp, 'return_plans_date_from')
      ? resp.return_plans_date_from
      : '',
    returnPlansDateTo: exists(resp, 'return_plans_date_to')
      ? resp.return_plans_date_to
      : '',
    dunningDateFrom: exists(resp, 'dunning_date_from')
      ? resp.dunning_date_from
      : '',
    dunningDateTo: exists(resp, 'dunning_date_to') ? resp.dunning_date_to : '',
    branchCodeFrom: exists(resp, 'branch_code_from')
      ? resp.branch_code_from
      : '',
    branchCodeTo: exists(resp, 'branch_code_to') ? resp.branch_code_to : '',
    radioBranchType: exists(resp, 'radio_branch_type')
      ? resp.radio_branch_type
      : '1',
    radioUserType: exists(resp, 'radio_user_type') ? resp.radio_user_type : '1',
    userCodeFrom: exists(resp, 'user_code_from') ? resp.user_code_from : '',
    userCodeTo: exists(resp, 'user_code_to') ? resp.user_code_to : '',
    radioUpdate: exists(resp, 'radio_update') ? resp.radio_update : '2',
    isUserOutputMultiple: resp.is_user_output_multiple,
    isOrderTelInclude: resp.is_order_tel_include,
    isNotLostCollection: resp.is_not_lost_collection,
    isNotLostProcedure: resp.is_not_lost_procedure,
    isRsvCollection: resp.is_rsv_collection,
    isOtherDunningDoc: resp.is_other_dunning_doc,
    isOutputParents: resp.is_output_parents,
    targetAge: exists(resp, 'target_age') ? resp.target_age : '0',
    isOutputTitle: resp.is_output_title,
    isMailApplicant: resp.is_mail_applicant,
    isOutputDeterrence: resp.is_output_deterrence,
    batchType: resp.batch_type
  }
}
